// extracted by css-extract-rspack-plugin
var _1 = "column-name-tMF8R6";
var _2 = "column-name-tMF8R6";
var _3 = "filter-OeJhkj";
var _4 = "table-WpoiHq";
export { _1 as "column-name", _2 as "columnName", _3 as "filter", _4 as "table" }
